import moment from 'moment'

export default (date: string): string => {
    return moment(date).fromNow(true)
}
